<template>
  <div class="w-100">
    <!-- <kendo-dialog
      ref="confirmDialog"
      :modal="true"
      :width="300"
      :title="'Confirm Remove'"
      :visible="false"
    >
      Are you sure that you want to remove it ?
      <kendo-dialog-action :text="'OK'" :action="remove()"></kendo-dialog-action>
      <kendo-dialog-action :text="'Cancel'" :primary="true"></kendo-dialog-action>
    </kendo-dialog> -->
    <form ref="form" v-kendo-validator novalidate @submit.prevent="add">
      
      <!-- <div class="page-header d-flex w-100"> -->
      <!-- <div class="title-col d-flex w-50">
          <span class="title-icon">
            <span class="nt-plus-square-fill"></span>
          </span>
          <span class="title-text">Product and Packages</span>
      </div>-->
      <!-- <div class="text-right ml-auto">
          <button class="k-button k-primary ml-2" type="button" @click="save" v-if="!readOnly">Save</button>
      </div>-->
      <!-- </div> -->
      <div class="page-body">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label class="required-field">Product</label>
              <kendo-dropdownlist
                class="w-100"
                :data-source="products"
                v-model="productName"
                :option-label="'Select'"
                :data-text-field="'name'"
                :data-value-field="'id'"
                :data-item-key="'productID'"
                :value-primitive="true"
                @change="productEvent"
                :item-key="'value'"
                name= "Product"
                :required="true"
                :disabled="productDisabled"
              ></kendo-dropdownlist>
            </div>
          </div>
          <div class="col-sm-4" style="width: 400px;">
            <div class="form-group">
              <label class="required-field">Package</label>
              <kendo-dropdownlist
                class="w-100"
                :data-source="getProductPackages(productId)"
                v-model="packageName"
                :option-label="'Select'"
                :data-text-field="'name'"
                :data-value-field="'id'"
                :data-item-key="'packageId'"
                :value-primitive="true"
                @change="packageEvent"
                :item-key="'value'"
                name= "Package"
                :required="true"
              ></kendo-dropdownlist>
            </div>
          </div>
          <div class="col-sm-2">
            <button style="border-radius: 5px;" class="k-button k-green ml-2 mt-4" type="submit">{{!edited?'Add':'Update'}}</button>
            <!-- <input
            style="border-radius: 5px;"
              type="button"
              icon="add"
              class="k-button k-green ml-2 mt-4"
              value="ADD"
              @click="add"
            /> -->
          </div>
        </div>

        <!-- <div class="add-on-div">
          <add-on-selection></add-on-selection>
        </div> -->
        <div v-if="tableData.length" class="d-flex">
          <div class="prod-package-div">
            <label>Product & Package </label>
            <!-- <div class="row" v-for="(product,index) in tenantProduct" :key="product.id">
              <div class="col-sm-4">{{product.productName.name}}</div>
              <div class="col-sm-2">{{product.package.name}}</div>
              <div class="col-sm-4">
                <span
                  v-if="product.package.name&&product.productName.name"
                  class="ml-2 nt-minus-circle-fill"
                  @click="removeProduct(index)"
                ></span>
              </div>
            </div>-->
            
            <div class="bg-white ml-1">
              <b-table striped hover :fields="fields" :items="tableData">
                <template #cell(activated)="data" v-if="tenant.activated == true">
                  <span>
                    <kendo-switch
                    name="switch"
                    v-model="data.item.isActive"
                    @change="changeActivation(data.item)"
                    ></kendo-switch>
                  </span>
                </template>
                <template v-slot:cell(action)="config">
                  <span class="action-icon nt-edit mx-1 k-link" @click="edit(config.index)"></span>
                  <span class="nt-trash-fill mx-1 k-link" @click="confirmDelete(config.index)"></span>
                </template>
              </b-table>
            </div>
          </div>

          <div class="features-div p-2">
            <label>Features</label>
            <div class="feature-list w-100 bg-white">
              <ul>
                <li
                  class="feature-list-view"
                  v-for="feature in featureList"
                  :key="feature.id"
                  v-bind:feature="feature"
                >
                  <span>{{ feature.featureName }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- <div class="buttons text-right">
          <button type="button" class="save-button btn btn-primary ml-3 rounded-border"  @click="save">Save</button>
          <button type="button" style="color: #0047b2;" class="save-button btn ml-3 rounded-border" @click="activate">Save & Activate</button>
          <button type="button" style="margin-right: 10px;" class="save-button btn btn-default ml-3" @click="close">Cancel</button>
        </div> -->
      </div> 
    </form>
    <DialogBox
    ref="removeTenantDtl"
    @OkMethod="OkMethod"
    @closed="closeDialog"
    ></DialogBox>
  </div>
  
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { createNamespacedHelpers, mapGetters } from "vuex";
const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "onboarding"
);
import { notifyApiError, notify } from "../../utils/notification-helper";
import DialogBox from "@/components/DialogBox.vue";
// import AddOnSelection from "./AddOnSelection";
export default {
  //  data: function () {
  //   return {
  //     features:[],
  //   }
  //  },
  computed: {
    ...mapFields(["products", "onboarding.tenantPackage", "onboarding.product.productName", "onboarding.product.packageName","onboarding.product.isActive"]),
    // ...mapMultiRowFields(["onboarding.tenantProduct"]),
    ...mapGetters(["getPackages", "getProductDetails"]),
    ...mapState(["productArray", "productId", "packId","tenantProduct","tenant","editField"]),
    featureList() {
      let features = [];
      if(this.tableData && this.tableData.length>0) {
        this.tableData.forEach(item => {
          let filteredData = [];
          if(this.editField == true) {
          filteredData = this.$store.state.packageData.filter(data =>data.id == item.packageID && data.productID == item.productID);
          } else {
          filteredData = this.$store.state.packageData.filter(data =>data.id == item.packageId && data.productID == item.productID);  
          }
          if(filteredData && filteredData.length>0) {
            filteredData[0].modules.forEach(data => {
              if(data.features instanceof Array  && data.features.length > 0)
                features = [...features, ...data.features]
              });
          }
        });
      }
      return features;
    },
    productDisabled() {
      if(this.edited == true) {
        return true;
      } else {
        return false
      }
    }
  },

  props: ["readOnly"],
  data: function() {
    return {
      fields: [
        {  key: "packageName", sortable: true },
        { key: "productName" },
        "action",
      ],
      edited: false,
      tableData: [],
      editedIndex: 0,
      removedIndex: 0,
      // fields: [{ key: "product" }, { key: "package" }, "action"]
    };
  },
  methods: {
    ...mapActions(["saveProduct", "addProducts","editProducts","resetState","activateTenant"]),
    ...mapMutations([
      "packageEvent",
      "productEvent",
      "removeProduct",
      "setSelectedTab", 
      "changeProductId"
    ]),
    save: function() {
      this.$router.push("/user-role")
      this.canContinue(); //TODO remove
      this.saveProduct()
        .then(message => {
          notify(message);
          this.canContinue();
          
        })
        .catch(notifyApiError);
    },
    activate() {
      this.activateTenant()
        .then(message => {
          notify(message);
          this.resetState();
          this.$store.dispatch("loadTenants", null, { root: true });
          this.$router.push("/add-tenant");
        })
        .catch(notifyApiError);
    },
    close() {
      this.$router.push("tenant-management"); 
    },
    getProductPackages(product) {
      let packages;
      if (!product) {
        return [];
      } else {
        packages = this.getPackages(product);
        return packages;
      }
    },
    getProductPackage(product) {
      if (!product || !product.productID) {
        return [];
      }
      const packages = this.getPackages(product.productID);
      return packages;
    },
    async getDataOnload() {
      this.tableData = this.tenantProduct;
      if(this.tenant.activated == true) {
        let tempData = this.fields.filter(item =>item.key == 'activated');
        if(tempData && tempData.length == 0) {
          this.fields.push({ key: "activated" })
        }
      }
      // this.field.push({ key: "activated" }),
      this.$store.dispatch("getFeature");
    },
    canContinue() {
      this.$emit("can-continue", { value: true });
    },
    edit(index) {
      // if(!this.edited) {
        this.edited = true;
        this.productName = this.tenantProduct[index].productID
        this.packageName = this.tenantProduct[index].packageId
        this.isActive = this.tenantProduct[index].isActive
        this.changeProductId(this.productName);
        this.editedIndex = index;
      // } else {
      //   notifyWarn("Please Add the selected Product First")
      // }
    },
    add: function() {
      if (!this.kendoValidator.validate()) {
        return;
      }
      if(this.edited) {
        this.editProducts();
      } else {
        this.addProducts();
      }
      this.tableData = this.tenantProduct;
      this.productName= "";
      this.isActive = false;
      this.packageName=this.getProductPackages("");
      this.edited = false;
      this.kendoValidator.hideMessages();
    },
    removeDialog(index) {
      this.$refs.confirmDialog.kendoWidget().open();
      this.removedIndex = index
    },
    remove() {   
        this.removeProduct(this.removedIndex)
        this.tableData = this.tenantProduct
    },
    confirmDelete(e) {
      this.removedIndex = e;
      this.$refs.removeTenantDtl.openWindow();
    },
    OkMethod() {
      this.remove()
    },
    closeDialog() {
      this.$refs.removeTenantDtl.closeWindow();
    },
    changeActivation(e) {
      this.isActive = e.isActive;
    }
    //     productEvent(e){
    //   console.log(e.sender.value())
    //   this.productId = e.sender.value()
    // }
  },
  created: function() {
    this.getDataOnload();
  },
  components: {
    DialogBox,
    // AddOnSelection
  }
};
</script>

<style>
.add-on-div {
  margin: 20px auto;
  background: white;
  width: 99%;
}

.prod-package-div {
  width: 60%;
}

.features-div {
  width: 40%;
  margin-left: 40px;
}

.feature-list {
  height: 180px;
  overflow-y: scroll;
  border: 1px solid rgba(33, 37, 41, 0.15);
}

.feature-list ul {
  list-style: none;
  padding-left: 20px;
}

.feature-list li span {
  font-size: 14px;
  display: inline-block;
  margin-top: 10px;
}

::-webkit-scrollbar {
  width: 15px;
}

.save-button{
  width: 150px;
}

.k-switch.k-widget {
  width: 40px;
  height: 20px;
}

.k-switch-handle {
  font-size: 0.5rem !important;
  margin-bottom: 1rem;
}

/* .k-animation-container-relative {
    width: 100%;
} */

</style>